import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

import { Product, ProductImage, Service, ShoppingCartItem } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';
import { ProductDataService } from 'src/app-client/_dataservices/ProductDataService';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { GlobalConstants, ShoppingProduct } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';

@Component({
  selector: 'app-successful-purchase',
  templateUrl: './successful-purchase.component.html',
  styleUrls: ['./successful-purchase.component.css'],
})
export class SuccessfulPurchaseComponent implements OnInit
{
  public currentCart: ShoppingCartItem[];
  public defaultImage = GlobalConstants.altProductImagePath;
  public purchaseCode:string = "";
  public orderId: number;
  public currentOrder: any;
  public currentProduct: any;
  public isPendingPayment: boolean = false;
  public percentageForMSIUsage : number = 0;
  public subtotal: number;
  constructor(
    private router: Router,
    public shoppingCartDataService: ShoppingCartDataService,
    protected route: ActivatedRoute,
    public orderDataService: OrderDataService,
    private productDataService: ProductDataService
  )
  {

  }


  ngOnInit(): void
  {
    this.shoppingCartDataService.getPercentageForMSIUsage().subscribe(res=>{
      this.percentageForMSIUsage = res;
    });

    this.route.paramMap
    .subscribe(params => 
    {
      setTimeout(() => {
        this.orderId = +params.get('orderId');
        if(this.orderId != 0 && this.orderId != null)
        {
          this.orderDataService.getById(this.orderId, this.onGetQueryDefForGetById())
          .subscribe((response) => {
            this.isPendingPayment = true;
            this.getPurchasedCode();
            this.currentOrder = response;
            this.productDataService.getById(this.currentOrder.orderDetail[0].product.id)
            .subscribe((response2)=>{
              this.currentProduct = response2;
            })
          });
        }
        else
        {
          this.subtotal = this.shoppingCartDataService.getTotal();
          this.shoppingCartDataService.getItems()
          .pipe(takeUntil(this.shoppingCartDataService.unsubscribeShoppingCart))
          .subscribe(cart =>
          {
            this.currentCart = JSON.parse(JSON.stringify(cart));
    
            if (this.currentCart.length == 0)
            {
              this.router.navigate(["ecommerce"]);
              return;
            }
            this.getPurchasedCode();
            this.shoppingCartDataService.unsubscribeShoppingCart.next(true);
            this.onClearShoppingCart();
    
          }, (fail) =>
          {
    
          });
        }
      });
    });





  }

  ngAfterViewInit(): void
  {
  }

  private getPurchasedCode()
  {
    this.route.paramMap.subscribe(params =>
    {
      this.purchaseCode = params.get('Code');
    });
  }

  private getCurrentOrder()
  {
    this.route.paramMap.subscribe(params =>
    {
      this.purchaseCode = params.get('Code');
    });
  }

  private onClearShoppingCart(): void
  {
    this.shoppingCartDataService.onClearItems();
  }

  public getItemImage(images: ProductImage[]): string
  {
    if(!this.isPendingPayment)
    {
      return images.length > 0 ? images[0].url : this.defaultImage;
    }
    else
    {
      return images.length > 0 ? images[0].url : this.defaultImage;
    }
  }

  public isProduct(item: Product | Service): boolean
  {
    return this.shoppingCartDataService.isProduct(item);
  }

  public hasAdditionalServices(myproduct: ShoppingProduct)
  {
    return myproduct.hasDentalMonitoring || myproduct.isComplexCase || myproduct.quantityExtraAligners > 0;
  }

  public goToEcommerceTienda()
  {
    this.router.navigate(["ecommerce/tienda"]);
  }

  public goToMisCompras()
  {
    this.router.navigate(['/ecommerce/mis-compras']);
  }
  protected onGetQueryDefForGetById()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "OrderDetail,OrderDetail.Product";
    return queryDef;
  }


  getTotalWithOrder():any{
    return (+this.currentOrder.total + this.currentOrder.percentageAmountForMSIUsage).toFixed(2)
  }

  public getTotalWOOrder(): string
  {
    return(this.subtotal + this.percentageForMSIUsage).toFixed(2);
  }

}
